<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.path)">
                <v-col md="3" cols="12">
                    <v-expansion-panels v-model="panel">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Others Info</v-expansion-panel-title
                            >

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit" ref="addIssue" id="addIssue">
                                    <v-row class="pa-2">
                                        <v-col cols="12">

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="from_warehouse_id.value.value"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="from_warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                From Warehouse
                                                <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="to_warehouse_id.value.value"
                                                :items="getWarehouseList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="to_warehouse_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    To Warehouse
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>
                                            
                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Transfer Date"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi-calendar"
                                                single-line
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="transfer_date.value.value"
                                                :error-messages="transfer_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Transfer Date
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>    
                                            
                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="transfer_type.value.value"
                                                :items="transferTypeOptions"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="slug"
                                                :error-messages="transfer_type.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                Transfer Type
                                                <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>
                                            
                                        </v-col>
                                    </v-row>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>

                <v-col md="9" cols="12">
                    <v-expansion-panels v-model="panel2">
                        <v-expansion-panel>
                            <v-expansion-panel-title
                                color="blue-grey-lighten-4"
                                class="panel-header"
                                >Item Info</v-expansion-panel-title
                            >

                            <v-expansion-panel-text>
                                <v-form @submit.prevent="submit" ref="addIssue" id="addIssue">
                                    <v-row class="pt-2 justify-center">
                                        <v-col cols="8">
                                            <v-autocomplete
                                                label="Search Prdouct Name"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="product_id.value.value"
                                                :items="getProductMapList"
                                                :item-title="(item) => `${item.product.code} - ${item.product.name}`"
                                                item-value="product_id"
                                                @update:model-value="addCart"
                                                @keydown.enter="addCart"
                                                autocomplete="off"
                                                clearable
                                            ></v-autocomplete>
                                        </v-col>

                                        <v-col cols="1">
                                        <v-btn class="bg-primary" @click="addCart">ADD</v-btn>
                                        </v-col>
                                    </v-row>

                                    <!-- Cart Table -->
                                    <v-row class="pt-0">
                                        <v-col cols="12">
                                            <v-table
                                                density="compact"
                                                :loading="loading"
                                                fixed-header
                                                class="table-dotted-border-bottom"
                                                style="height: 40vh; overflow-y: scroll"
                                            >

                                                <thead>
                                                    <tr>
                                                        <th class="text-center" style="width: 5%">SL</th>
                                                        <th class="text-left" style="width: 25%">
                                                            Code
                                                        </th>
                                                        <th class="text-left" style="width: 25%">
                                                            Product Name
                                                        </th>
                                                        <th class="text-center" style="width: 20%">
                                                            Available Quantity
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                            Quantity
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                            Sale Rate
                                                        </th>
                                                        <th class="text-center" style="width: 15%">
                                                            Amount
                                                        </th>
                                                        <th class="text-center" style="width: 15%">Unit</th>
                                                        <th class="text-center" style="width: 10%">
                                                            Action
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr
                                                        v-for="(item, index) in cart"
                                                        v-if="cart.length > 0"
                                                        :key="index"
                                                    >
                                                        <td class="text-center py-1">{{ index + 1 }}</td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                        {{ item.product_code }}
                                                        </td>
                                                        <td
                                                        class="text-left py-1"
                                                        style="white-space: normal"
                                                        >
                                                        {{ item.product_name }}
                                                        </td>
                                                        <td
                                                        class="text-center py-1"
                                                        >
                                                            {{ item.availableQty }}
                                                        </td>
                                                        <td class="text-right py-1">
                                                            <v-text-field
                                                                :reverse="false"
                                                                controlVariant="stacked"
                                                                label=""
                                                                type="number"
                                                                style="width: 80px;"
                                                                :hideInput="false"
                                                                :inset="false"
                                                                :min="1"
                                                                density="compact"
                                                                variant="outlined"
                                                                bg-color="grey-lighten-4"
                                                                v-model="item.qty"
                                                                :error-messages="item.qty < 1 ? 'Quantity must be greater than 0' : '' "
                                                                @update:model-value="item.amount = item.qty * item.rate"
                                                                @blur="item.amount = item.qty * item.rate"
                                                            ></v-text-field>
                                                        </td>

                                                        <td class="text-center py-1">
                                                            {{ item.rate }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                            {{ item.amount }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                            {{ item.unit_name }}
                                                        </td>
                                                        <td class="text-center py-1">
                                                            <v-icon
                                                                size="small"
                                                                color="red"
                                                                class="delete-button"
                                                                @click="removeFromCart(index)"
                                                            >
                                                                mdi-delete
                                                            </v-icon>
                                                        </td>
                                                    </tr>

                                                    <tr v-else-if="loading == true">
                                                        <td colspan="6" class="text-center">
                                                            <v-skeleton-loader
                                                                type="heading"
                                                                :loading="loading"
                                                            />
                                                        </td>
                                                    </tr>

                                                    <tr v-else>
                                                        <td colspan="6" class="text-center text-red">
                                                            You have no item
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </v-table>
                                        </v-col>
                                    </v-row>
                                    <!-- Close Cart Table -->

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="pt-2">
                                            <v-col cols="8">
                                                <v-textarea
                                                label="Description"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="remarks.value.value"
                                                :error-messages="remarks.errorMessage.value"
                                                autocomplete="off"
                                                rows="3"
                                                clearable
                                                ></v-textarea>
                                            </v-col>

                                            <v-col cols="4">
                                                <v-layout class="justify-end">
                                                    <v-btn
                                                        class="bg-grey-darken-1 me-2"
                                                        variant="flat"
                                                        @click="submitForm(0)"
                                                        >DRAFT</v-btn
                                                    >

                                                    <v-btn
                                                        class="bg-primary"
                                                        variant="flat"
                                                        @click="submitForm(1)"
                                                        >POST</v-btn
                                                    >
                                                </v-layout>
                                            </v-col>
                                        </v-row>
                                    </v-card-actions>
                                </v-form>
                            </v-expansion-panel-text>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { useRouter } from "vue-router";

export default {
  components: {},
    data: () => ({
        panel: [0],
        panel2: [0],
        loading: false,
        errorMessages: "",
        search: "",
        transferTypeOptions:[
            {
                slug: "direct-transfer",
                name: "Direct Transfer"
            },
            {
                slug: "send-transfer-request",
                name: "Send Transfer Request"
            },
        ],
        cart: [],
    }),
    watch: {},
    created() {
        if (this.$store.getters.getWarehouseList.length === 0) {
            this.$store.dispatch("getWarehouseList");
        }
        if (this.$store.getters.getProductMapList.length === 0) {
            this.$store.dispatch("getProductMapList");
        }
    },
    computed: {
        getWarehouseList() {
            return this.$store.getters.getWarehouseList;
        },
        getProductMapList() {
            let products = this.$store.getters.getProductMapList;
            return products.filter(
                (item) =>
                item.branch_id == this.$store.getters.getAuthUser.branch_id &&
                item.status == 1
            );
        },
    },
    methods: {
        addCart() {
            let cartInd = this.cart.findIndex(
                (p) => p.product_id == this.product_id.value.value
            );
            if (this.product_id.value.value == null) {
                toast.error("Please select a Product");
                this.cartReset();
                return false;
            }
            if (cartInd > -1) {
                toast.error("Product already added in cart");
                this.cartReset();
                return false;
            }

            let product = this.getProductMapList.find(
                (item) => item.product_id == this.product_id.value.value
            );
            
            product = product.product;

            let item = {
                product_id: this.product_id.value.value,
                product_code: product.code,
                product_name: product.name,
                availableQty: product.available_inventory_qty || 0,
                qty: 1,
                rate: product.sale_rate,
                amount: product.sale_rate * 1,
                unit_id: product.unit_id,
                unit_name: product.unit.name,
            };

            this.cart.push(item);
            this.$nextTick(() => {
                this.cartReset();
            });
        },
        removeFromCart(index) {
            if (confirm("Are You Sure?")) {
                this.cart.splice(index, 1);
            }
        },
        cartReset() {
            this.product_id.value.value = null;
        },
    },
    setup() {
        const { handleSubmit, resetForm } = useForm({
        validationSchema: yup.object({
            transfer_date: yup.date().required().label("Transfer Date"),
            transfer_type: yup.string().required().label("Transfer Type"),
            from_warehouse_id: yup.string().required().label("From warehouse is required."),
            to_warehouse_id: yup.string().required().label("To warehouse is required."),
        }),
        });

        const transfer_id = useField("transfer_id");
        const from_warehouse_id = useField('from_warehouse_id');
        const to_warehouse_id = useField('to_warehouse_id');
        const transfer_date = useField('transfer_date');
        const transfer_type = useField('transfer_type');
        const remarks = useField('remarks');
        const status = useField('status');

        const product_id = useField('product_id');
        const errorMessages = ref("");
        const cart = ref([]);
        const loading = ref("");
        const buttonText = ref("");
        buttonText.value = "Save";
        const store = useStore();
        const router = useRouter();
        const currentStatus = ref(0);

        const submitForm = (status) => {
            currentStatus.value = status;
            submit();
        };

        const submit = handleSubmit((values) => {
            values.status = currentStatus.value;
            values.cart = cart.value;
            // console.log(values);
            store
                .dispatch("saveUpdateInvItemTransfer", values)
                .then((response) => {
                resetForm();
                buttonText.value = "Save";
                cart.value = [];
                toast.success(response.data.message, {
                    timeout: 3000,
                });
                setTimeout(() => {
                    router.push({ name: "transfer-record" });
                }, 2000);
                })
                .catch((error) => {
                toast.error(error.response.data.message);
                });
        });
        return {
            submit,
            submitForm,
            transfer_id,
            from_warehouse_id,
            to_warehouse_id,
            transfer_date,
            transfer_type,
            product_id,
            cart,
            remarks,
            status,
            errorMessages,
            buttonText,
            loading,
        };
    },  
    mounted() {
        const id = this.$route.query.id;
        if (id) {
            this.$store.commit("SET_LOADING", { color: "primary" });

            this.$nextTick(() => {
                this.$store
                .dispatch("getInvItemTransferById", id)
                .then((data) => {
                    // console.log(data);
                    this.isEntryMode = false;
                    let item = data;

                    this.transfer_id.value.value = item.id;
                    this.from_warehouse_id.value.value = item.from_warehouse_id;
                    this.to_warehouse_id.value.value = item.to_warehouse_id;
                    this.transfer_date.value.value = item.transfer_date;
                    this.transfer_type.value.value = item.transfer_type;
                    
                    this.cart.value = [];

                    (item.inv_item_transfer_details || []).forEach((item) => {
                        this.cart.push({
                            product_id: item.product_id,
                            product_code: item.product?.code || "",
                            product_name: item.product?.name || "",
                            availableQty: item.product.available_inventory_qty,
                            qty: item.qty,
                            unit_id: item.product.unit?.id || "",
                            unit_name: item.product.unit?.name || "",
                            amount: item.rate*item.qty,
                            rate: item.rate,
                            total: item.qty * item.rate,
                        });
                    });
                    this.remarks.value.value = item.remarks
                        ? item.remarks
                        : "";
                    this.$store.commit("UNSET_LOADING");
                })
                .catch((error) => {
                    this.$store.commit("UNSET_LOADING");
                    console.error("Failed to fetch item:", error);
                });
            });
        } else {
            this.isEntryMode = true;
        }
    },
};
</script>
